<mat-card id="cadastro">
  <mat-card-header>
    <div fxLayout="row">
      <div>
        <h3>Cadastro do Solicitação</h3>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>

    <h4>ATENÇÃO:
      <br>1- Sua solicitação só poderá ser gravada com Todos os Campos preenchidos
      <br>2- Os arquivos para Upload só poderão ser do tipo PDF
    </h4>

    <form [formGroup]="form"  class="formulario">


      <div class="form_linha" fxLayout.xs="column" class="titupload">
        <h4>
          Identificação
        </h4>
      </div>

      <div class="form_linha" fxLayout.xs="column">
        <section class="campo_flex tamanho_100 flex_wrap">
          <div class="campo_flex tamanho_25">- EDITAL -</div>

          <div class="campo_flex tamanho_50" >

            
            <input type="file" name="file1" id="file1" (change)="fileChange($event,m_tip)" >

            <a href="{{caminhoArquivosUpload}}/{{m_filename}}" target="_blank">{{m_filename}}</a>

          </div>

        </section>
      </div>


    </form>

  </mat-card-content>

</mat-card>
